/**
 * Wo man zuletzt war — damit die Anwendung dort wieder aufmacht.
 *
 * Aus dem Betrieb: die Web-App auf dem iPhone nimmt beim Öffnen von sich aus
 * die zuletzt besuchte Seite wieder auf, das iPad beginnt bei der Übersicht.
 * Zwei Geräte, zwei Verhalten, keines davon gewollt. Und weil sich die alte
 * Adresse auf eine gelöschte Reise bezog, stand da „Diese Reise gibt es
 * nicht" — eine Sackgasse gleich beim Öffnen.
 *
 * Gemerkt wird deshalb hier, im Gerät, und nicht auf dem Server: welcher Chat
 * zuletzt offen war, ist Ansichtssache dieses Geräts. Wer am Telefon in einer
 * Reise schreibt und am Rechner in einer anderen liest, will nicht, dass ihm
 * das eine das andere umstellt.
 *
 * Gemerkt werden **Chats und die Übersicht**, sonst nichts. Die Übersicht
 * gehört dazu, obwohl es dorthin nichts zu leiten gibt: wer zur Liste
 * zurückgegangen ist und dann neu lädt, will die Liste sehen und nicht wieder
 * in den Chat fallen, aus dem er gerade gekommen ist. Einstellungen und
 * Formulare gehören nicht dazu — nach einem Neustart in „Reise anlegen" zu
 * landen wäre keine Hilfe.
 */
const MARKE = 'tb.letzter-chat'

/** Genau die beiden Wege, die ein Chat sein können. */
const CHAT = /^\/t\/\d+(\/with\/\d+)?$/

export function istChat(pfad: string): boolean {
  return CHAT.test(pfad)
}

export function merkeOrt(pfad: string): void {
  if (pfad !== '/' && !istChat(pfad)) return
  try {
    localStorage.setItem(MARKE, pfad)
  } catch {
    // Nicht merken zu können ist kein Grund, nicht zu bedienen.
  }
}

/**
 * Wohin beim Start zu leiten ist — oder `null`, wenn nirgendwohin.
 *
 * Geprüft wird auch beim Lesen: was hier steht, geht ungefragt in die
 * Adresszeile, und ein alter oder verbogener Eintrag hat dort nichts zu
 * suchen. Die gemerkte Übersicht ergibt hier folgerichtig `null` — man ist ja
 * schon da.
 */
export function letzterChat(): string | null {
  try {
    const pfad = localStorage.getItem(MARKE)
    return pfad !== null && istChat(pfad) ? pfad : null
  } catch {
    return null
  }
}

export function vergissChat(): void {
  try {
    localStorage.removeItem(MARKE)
  } catch {
    // Siehe oben.
  }
}
